// src/components/video/VideoDetailCard.jsx
import AutoMarquee from "../common/AutoMarquee";
import AuthCard from "../auth/AuthCard";
import SecureHlsPlayer from "./SecureHlsPlayer";


function splitPrettyTitle(raw) {
    if (!raw) return { head: "운동 영상", sub: "" };
    let head = raw.trim();
    let sub = "";

    const pm = head.match(/^(.*?)[\s]*\((.+)\)\s*$/);
    if (pm) {
        head = pm[1].trim();
        sub = pm[2].trim();
    } else {
        const hy = head.split(" - ");
        if (hy.length >= 2) {
            head = hy[0].trim();
            sub = hy.slice(1).join(" - ").trim();
        } else {
            const hy2 = head.split("-");
            if (hy2.length >= 2) {
                head = hy2[0].trim();
                sub = hy2.slice(1).join("-").trim();
            }
        }
    }
    if (!head) head = raw;
    return { head, sub };
}

export default function VideoDetailCard({
    title,
    poster = "",
    guide = [],
    vidPath = "",
    videoUrl = "",
    onBack,
}) {
    const pretty = splitPrettyTitle(title);
    const hasVideo = !!vidPath || !!videoUrl;

    return (
        <AuthCard
            className="flex-1 w-full mx-auto"
            title={
                <AutoMarquee
                    className="text-center font-semibold break-keep"
                    reserveRight={14}
                    maxInline="36rem"
                >
                    {pretty.sub
                        ? `${pretty.head} (${pretty.sub})`
                        : pretty.head}
                </AutoMarquee>
            }
        >
            <div className="flex flex-col flex-1 pb-24 md:pb-28">
                {/* 상단 영상/포스터 */}
                <div className="mt-2">
                    {hasVideo ? (
                        vidPath ? (
                            <SecureHlsPlayer
                                vidPath={vidPath}
                                poster={poster}
                                autoPlay
                            />
                        ) : (
                            <video
                                controls
                                playsInline
                                autoPlay
                                muted
                                controlsList="nodownload noplaybackrate"
                                disablePictureInPicture
                                className="w-full aspect-video rounded-2xl overflow-hidden bg-black cursor-pointer"
                                src={videoUrl}
                                poster={poster}
                                onClick={(e) => {
                                    const vv = e.currentTarget;
                                    vv.paused ? vv.play() : vv.pause();
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === " " || e.key === "Enter") {
                                        e.preventDefault();
                                        const vv = e.currentTarget;
                                        vv.paused ? vv.play() : vv.pause();
                                    }
                                }}
                                tabIndex={0}
                            />
                        )
                    ) : (
                        // 🔹 영상이 아직 준비 안 된 경우
                        <div className="w-full aspect-video rounded-2xl border border-dashed border-gray-300 bg-gray-50 flex flex-col items-center justify-center">
                            <p className="text-gray-600 font-medium">
                                영상이 준비되지 않았습니다.
                            </p>
                            {poster ? (
                                <img
                                    src={poster}
                                    alt="poster"
                                    className="mt-3 h-20 w-36 object-cover rounded-lg border border-gray-200"
                                />
                            ) : null}
                        </div>
                    )}
                </div>

                {/* 운동 가이드 카드 */}
                <section className="mt-4 md:mt-5 rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
                    <h3 className="text-lg md:text-xl font-bold mb-2 text-center">
                        운동 가이드
                    </h3>
                    <div className="border-b border-gray-200 mb-3"></div>
                    {guide && guide.length ? (
                        <ol className="list-decimal ml-5 space-y-1.5 text-sm md:text-base text-gray-600">
                            {guide.map((line, i) => (
                                <li key={i} className="break-keep">
                                    {line}
                                </li>
                            ))}
                        </ol>
                    ) : (
                        <p className="text-center text-gray-500 py-4">
                            가이드 정보가 없습니다.
                        </p>
                    )}
                </section>

                {/* 하단 이전 버튼 */}
                <div className="mt-6 flex justify-center">
                    <button
                        type="button"
                        onClick={onBack}
                        className="w-full border border-gray-200 rounded-lg py-3 text-gray-700 font-medium hover:bg-gray-50 transition"
                    >
                        이전으로
                    </button>
                </div>
            </div>
        </AuthCard>
    );
}


